const $doc = $(document);
const $win = $(window);

$doc.on('click', '.js-btn-toggle', function(e) {
  e.preventDefault();

  const $this = $(this);
  const $target = $($this.data('target'));
  const className = $this.data('class');

  $target.toggleClass(className);

  if ($this.data('class-remove')) {
    const classRemove = $this.data('class-remove');

    $target.removeClass(classRemove);
  }

  if ($this.hasClass('js-btn-toggle-slide') && $win.width() < 1024) {
    $this
      .closest('.section-fixed--alt')
      .toggleClass('expanded')
      .find('.section__body')
      .slideToggle();
  };

  if ($this.hasClass('js-btn-search-desktop')) {
    setTimeout(function() {
      $('.js-search input').trigger('focus');
    }, 400);
  };
});



// WEBPACK FOOTER //
// ../assets/js/btn-toggle.js